import BankService from '@/store/services/bank.service.js';

export default {
  namespaced: true,
  state: {
    bankAccounts: [],
    selectedAccount: null,
    enablenowProviders: [],
  },
  getters: {
    getBankAccount: state => id => state.bankAccounts.find(item => item.id === id),
    getBankAccounts: state => state.bankAccounts,
    getSelectedAccount: state => state.selectedAccount,
    getEnablenowProviders: state => state.enablenowProviders,
  },
  mutations: {
    SET_BANK_ACCOUNTS (state, value) {
      state.bankAccounts = value
    },
    SET_ENABLENOW_PROVIDERS (state, value){
      state.enablenowProviders = value;
    },
    SET_SELECTED_ACCOUNT (state, value) {
      state.selectedAccount = state.bankAccounts.find(item => item.id === value)

      if (!state.selectedAccount) {
        state.selectedAccount = null;
      }
    },
    SET_SELECTED_ACCOUNT_BALANCE (state, account_id) {
      const selected_account = state.bankAccounts.find(bank => bank.id === account_id)
      state.selectedAccount.balance = selected_account.balance
    },
    DELETE_BANK_ACCOUNT (state, account_id) {
      state.bankAccounts = state.bankAccounts.filter(account => account.id !== account_id)
      if (account_id === state.selectedAccount.id && state.bankAccounts.length > 0) {
        state.selectedAccount = state.bankAccounts[0]
      }
      if (state.bankAccounts.length === 0) {
        state.selectedAccount = null
      }
    }
  },
  actions: {
    loadBankAccounts ({ commit, rootGetters }) {
      const company_id = rootGetters['main/getCompanyId']

      return BankService.list({ extended: true, company_profile: company_id }).then((response) => {
        commit('SET_BANK_ACCOUNTS', response.data)
      })
    },
    loadEnablenowProviders({ commit }){
      return BankService.getEnablenowBankList().then((response)=>{
        commit('SET_ENABLENOW_PROVIDERS', response.data)
        return response.data;
      })
    },
    mollieFinishAuthentication({ commit, rootGetters }, data) {
      return BankService.mollieFinishAuthentication(data)
    },
    enablenowGrantConsentSuccess({ commit, rootGetters }, data) {
      return BankService.enablenowGrantConsentSuccess(data)
    },
    deleteBankAccount ({ commit, state }, account_id) {
      return BankService.destroy(account_id).then(() => {
        commit('DELETE_BANK_ACCOUNT', account_id)
        commit('filterStore/SET_BANK_ACCOUNT', (state.selectedAccount) ? state.selectedAccount.id : null, { root: true })
        commit('filterStore/SET_COOKIES', null, { root: true })
        commit('filterStore/SET_UPDATE_FILTER_BANK', null, { root: true })
      })
    }
  }
}